import { render, staticRenderFns } from "./KhazinaInputDetailReportPrint.vue?vue&type=template&id=4fedf1b0&"
import script from "./KhazinaInputDetailReportPrint.vue?vue&type=script&lang=js&"
export * from "./KhazinaInputDetailReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports